import { combineReducers } from 'redux';

import anamnese from './anamnese/reducer';

export default combineReducers({
	anamnese,
});
